// src/pages/Apply/index.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../Dashboard.css";
import StepIdentity from "./StepIdentity";
import StepKitchen from "./StepKitchen";
import StepCompliance from "./StepCompliance";
import StepReviewSign from "./StepReviewSign";
import StepPayment from "./StepPayment";
// src/pages/Apply/index.jsx
import "./Apply.css"; // ⬅️ add this import at the top with the others
import api from "../../utils/api";





//const API = "http://localhost:5001";
const API = process.env.REACT_APP_API_URL;


export default function ApplyWizard() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // state hooks...
  const [app, setApp] = useState(null);
  const [data, setData] = useState({
    legal_name: "",
    trading_name: "",
    entity_type: "sole_trader",
    dob: "",
    start_date: "",
    prep_address: "",
    trading_address: "",
    activities: [],
    opening_hours: "",
    has_level2: false,
    allergen_process: "",
    insurance_policy: "",
    authority_name: "",
  });

  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});




  // --- helpers for validation ---
  const todayISO = () => new Date().toISOString().slice(0, 10);
  const addDays = (d, n) => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x.toISOString().slice(0, 10);
  };
  const isAdult = (iso) => {
    if (!iso) return false;
    const d = new Date(iso);
    const now = new Date();
    const adultCutoff = new Date(
      now.getFullYear() - 18,
      now.getMonth(),
      now.getDate()
    );
    return d <= adultCutoff;
  };
  const minStartDateISO = addDays(todayISO(), 28); // 28-day notice rule



// compute progress once (near top of component, after the hooks):
const progress = Math.min(100, Math.max(0, ((step - 1) / 4) * 100));



  const HOURS_OK = (s) =>
    typeof s === "string" &&
    s.trim().length >= 6 &&
    /[A-Za-z]/.test(s) &&
    /\d/.test(s); // e.g. has day + numbers

  const POLICY_OK = (s) => /^[A-Za-z0-9\-]{6,60}$/.test(String(s || ""));

  // map required field -> step
  const FIELD_STEP = {
    legal_name: 1,
    entity_type: 1,
    dob: 1,
    prep_address: 2,
    start_date: 2,
    opening_hours: 2,
    authority_name: 2,
    has_level2: 3,
    allergen_process: 3,
    insurance_policy: 3,
  };

  // validate only current step
  const validateStep = (s, d) => {
    const e = {};
    if (s === 1) {
      if (!d.legal_name?.trim()) e.legal_name = "Legal name is required.";
      if (!d.entity_type) e.entity_type = "Entity type is required.";
      if (!d.dob) e.dob = "Date of birth is required.";
      else if (!isAdult(d.dob)) e.dob = "You must be 18 or older.";
    }
    if (s === 2) {
      if (!d.prep_address?.trim() || d.prep_address.trim().length < 8)
        e.prep_address = "Enter your full preparation address.";
      if (!d.start_date)
        e.start_date = "Planned start date is required.";
      else if (d.start_date < minStartDateISO)
        e.start_date = `UK councils require 28 days' notice. Choose ${minStartDateISO} or later.`;
      if (!d.opening_hours?.trim() || !HOURS_OK(d.opening_hours))
        e.opening_hours =
          "Add your opening hours (e.g., Mon–Fri 10–18).";
      if (!d.authority_name?.trim())
        e.authority_name = "Local authority is required.";
    }
    if (s === 3) {
      if (d.has_level2 !== true && d.has_level2 !== false)
        e.has_level2 = "Select Yes or No.";
      if (!d.allergen_process?.trim() || d.allergen_process.trim().length < 10)
        e.allergen_process = "Briefly describe your allergen procedure (min 10 chars).";
      if (!POLICY_OK(d.insurance_policy))
        e.insurance_policy =
          "Enter your insurance policy number (6–60 letters/numbers).";
    }
    return e;
  };

  const goNext = async () => {
    const e = validateStep(step, data);
    setErrors(e);
    if (Object.keys(e).length) return;
    await saveDraft();
    setStep(step + 1);
  };

  // redirect if no token
  useEffect(() => {
    if (!token) navigate("/seller/login", { replace: true });
  }, [token, navigate]);

  // ensure a draft exists (or fetch existing draft)

useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const r = await api.post(
          `/auth/applications`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (ignore) return;
        setApp(r.data.application);
        const serverData = r?.data?.application?.data || {};
        setData((d) => ({ ...d, ...serverData }));

} catch (e) {
  if (!ignore) {
    // 👇 handle already-submitted case nicely
    if (
      e?.response?.status === 400 &&
      /already submitted/i.test(e?.response?.data?.error || "")
    ) {
      setSubmittedMsg(
        "✅ Your council registration has already been submitted and is now being processed. " +
        "We’ll update you once it’s complete. For questions, contact support@homefoodgrab.com."
      );
    } else {
      setErr(e?.response?.data?.error || "Could not start application");
    }
  }



      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [token]);







  const saveDraft = useCallback(
    async (patch = {}) => {
      if (!app) return;
      setSaving(true);
      setErr("");
      setMsg("");
      const newData = { ...data, ...patch };
      setData(newData);
      try {
        const r = await api.patch(
          `/auth/applications/${app.application_id}`,
          { data: newData },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setApp(r.data.application);
        setMsg("Saved");
        setTimeout(() => setMsg(""), 800);
      } catch (e) {
        setErr(e?.response?.data?.error || "Save failed");
      } finally {
        setSaving(false);
      }
    },
    [app, data, token]
  );




const submitApp = async (esign_name, declarations) => {
  if (!app) return;
  setErr("");
  setMsg("");
  setErrors({});
  try {
    await api.post(
      `/auth/applications/${app.application_id}/submit`,
      { esign_name, declarations },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setMsg("✅ Submitted. We’ll start your registration.");
    setTimeout(() => navigate("/seller/dashboard"), 1200);
  } catch (e) {
    const details = e?.response?.data?.details;
    if (details) {
      const eMap = {};
      (details.missing || []).forEach((f) => (eMap[f] = "Required"));
      setErrors(eMap);
      const first = (details.missing || [])[0];
      if (first && FIELD_STEP[first]) setStep(FIELD_STEP[first]);
      setErr("Please complete all required fields.");
    } else {
      setErr(e?.response?.data?.error || "Submit failed");
    }
  }
};




  // ---- Loading / error gates ----

const [submittedMsg, setSubmittedMsg] = useState("");

if (loading) return <p className="center">Loading…</p>;

  // 👇 if already submitted, stop wizard and just show message


// 👇 if already submitted, stop wizard and just show message
if (submittedMsg) {
  return (
    <div className="apply-bg">
      <section className="apply-card">
        <h3 className="apply-title">Council Registration</h3>
        <div className="card" style={{ textAlign: "center", padding: "2rem" }}>
          <p style={{ marginBottom: "1rem" }}>{submittedMsg}</p>
          <button
            className="btn"
            onClick={() => navigate("/seller/dashboard")}
            style={{ marginTop: "1rem" }}
          >
            Go to Dashboard
          </button>
          <button
            className="btn ghost"
            onClick={() => {
              localStorage.clear();
              navigate("/seller/login");
            }}
            style={{ marginTop: "1rem", marginLeft: "0.5rem" }}
          >
            Log out
          </button>
        </div>
      </section>
    </div>
  );
}




  if (err && !app)
    return (
      <div className="dashboard-content">
        <div className="toast error">{err}</div>
      </div>
    );

  return (
    <div className="apply-bg">
      <section className="apply-card">
        <div className="apply-head">
          <h3 className="apply-title">Register with your council — Application</h3>
          <div className="muted">
            Step {step} / 5 {saving ? "· Saving…" : ""}
          </div>
        </div>

        <div className="apply-progress">
          <span style={{ width: `${progress}%` }} />
        </div>

        {msg && <div className="toast">{msg}</div>}
        {err && <div className="toast error">{err}</div>}








    <div className="dashboard-content">
      {msg && <div className="toast">{msg}</div>}
      {err && <div className="toast error">{err}</div>}

      <section className="card" style={{ maxWidth: 820, margin: "2rem auto" }}>
        <div className="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <h3>Register with your council — Application</h3>
          <div className="muted">Step {step} / 5 {saving ? "· Saving…" : ""}</div>
        </div>

        {step === 1 && (
          <StepIdentity
            data={data}
            errors={errors}
            onChange={(patch) => setData((d) => ({ ...d, ...patch }))}
            onNext={goNext}
            // max DOB for 18+
            dobMax={addDays(todayISO(), -365 * 18)}
          />
        )}

        {step === 2 && (
          <StepKitchen
            data={data}
            errors={errors}
            onChange={(patch) => setData((d) => ({ ...d, ...patch }))}
            onBack={() => setStep(1)}
            onNext={goNext}
            minStartDate={minStartDateISO}
          />
        )}

        {step === 3 && (
          <StepCompliance
            data={data}
            errors={errors}
            onChange={(patch) => setData((d) => ({ ...d, ...patch }))}
            onBack={() => setStep(2)}
            onNext={goNext}
          />
        )}

        {step === 4 && (
          <StepPayment
            app={app}
            onBack={() => setStep(3)}
            onPaid={async () => {
              try {
                const r = await api.post(`/auth/applications`, {}, {
                  headers: { Authorization: `Bearer ${token}` },
                });
                setApp(r.data.application);
              } catch {}
              setStep(5);
            }}
          />
        )}

        {step === 5 && (
          <StepReviewSign
            data={data}
            app={app}
            onBack={() => setStep(4)}
            onEdit={(toStep) => setStep(toStep)}
            onSubmit={submitApp}
          />
        )}

</section>
  </div>



      </section>
    </div>
  );
}

